import React, { useState } from "react"
import { graphql } from "gatsby"
import styled from "styled-components"
import { useScrollYPosition } from "react-use-scroll-position"

import Layout from "../components/layout"
import SEO from "../components/seo"

const TextBox = styled.div`
    padding: ${props => (props.isMartina ? "0" : "2rem 2rem 8rem")};
    @media screen and (max-width: 767px) {
        padding: ${props => (props.isMartina ? "0" : "1rem 1rem 8rem")};
    }
`

export default function Template({
    data, // this prop will be injected by the GraphQL query below.
}) {
    const { content, toc } = data // data.markdownRemark holds our post data
    const { frontmatter, html } = content
    useScrollYPosition()
    const [playedMartina, setPlayedMartina] = useState(false)
    const isMartina = frontmatter.author === "Martina Copley"

    const nodes = toc.nodes.reduce((obj, item) => {
        obj[item.frontmatter.number] = item.frontmatter
        return obj
    }, {})

    const backOne =
        nodes[frontmatter.number - 1] || nodes[Object.keys(nodes).length]
    const forwardOne = nodes[frontmatter.number + 1] || nodes[1]

    const updateWidthAndHeight = () => {
        if (
            isMartina &&
            typeof document !== "undefined" &&
            document.getElementById("sampleImage")
        ) {
            const elX =
                window.innerWidth < 768
                    ? 19
                    : document
                          .getElementById("sampleImage")
                          .getBoundingClientRect().x
            document.getElementById("firstOne").style.marginLeft = `${elX}px`
            document.getElementById("blank").style.width = `${elX}px`
        }
    }

    React.useEffect(() => {
        window.addEventListener("resize", updateWidthAndHeight)
        setTimeout(updateWidthAndHeight, 1000)
        return () => window.removeEventListener("resize", updateWidthAndHeight)
    })

    return (
        <Layout
            leftLink={{
                text: backOne.linkText,
                link: backOne.path,
            }}
            rightLink={{
                text: forwardOne.linkText,
                link: forwardOne.path,
            }}
        >
            <SEO title={`${frontmatter.title} • ${frontmatter.author}`} />
            <TextBox
                dangerouslySetInnerHTML={{ __html: html }}
                isMartina={isMartina}
            />
        </Layout>
    )
}

export const pageQuery = graphql`
    query($path: String!) {
        content: markdownRemark(frontmatter: { path: { eq: $path } }) {
            html
            frontmatter {
                number
                author
                path
                title
            }
        }
        toc: allMarkdownRemark(
            sort: { order: ASC, fields: [frontmatter___number] }
            filter: { frontmatter: { path: { ne: "" } } }
        ) {
            nodes {
                frontmatter {
                    path
                    number
                    linkText
                }
            }
        }
    }
`
